import { axiosService } from '..';

export default class DeleteBusinessFrontPageHighlightService {
    public async execute(businessId: number, uniqueIdentifier: string): Promise<boolean> {
        return (await axiosService.instance.post(`businesses/organization/front-page/${businessId}/delete-highlight?uniqueIdentifier=${uniqueIdentifier}`)).data;
    }
}

export const deleteBusinessFrontPageHighlightService = new DeleteBusinessFrontPageHighlightService();
